import script from "./webPostingManager.vue?vue&type=script&lang=js"
export * from "./webPostingManager.vue?vue&type=script&lang=js"

import "./webPostingManager.vue?vue&type=style&index=0&id=2d4671f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4671f4"]])

export default __exports__